import apiEndpoints from '../../../apiEndpoints';
import { fetcher } from '../../utils/fetchers/fetcher';

export const requestDataset = (
  datasetId: string,
  token: string | null,
  forceHeader?: string
  //TODO: Create return type
): Promise<any> =>
  fetcher<any>(
    `${apiEndpoints.routes.datasets}/${datasetId}`,
    'GET',
    token,
    forceHeader
  );
